/**
 * Shared motion tokens (master prompt §8). Durations mirror the Tailwind
 * `transitionDuration` scale (fast/normal/slow) so CSS and JS/R3F animation
 * code agree on the same rhythm. `prefersReducedMotion()` is the single
 * check every animated component (hero, reveals, before/after, etc.) should
 * use instead of re-querying matchMedia ad hoc.
 */

export const motion = {
  duration: {
    fast: 0.15,
    normal: 0.27,
    slow: 0.55,
  },
  ease: {
    entrance: [0.16, 1, 0.3, 1] as const, // ease-out-expo — snappy arrival
    exit: [0.7, 0, 0.84, 0] as const, // ease-in-expo — quick dismissal
  },
} as const

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

/** True on devices whose primary input has no hover/fine pointer (touch). */
export function isCoarsePointer(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(pointer: coarse)').matches
}

/**
 * True at `lg` breakpoint (1024px) and up — matches Tailwind's `lg:` prefix
 * exactly, so JS-gated desktop/mobile variants (e.g. ProcessScrollJourney)
 * stay in sync with the CSS breakpoint that decides which one is visible.
 */
export function isDesktopViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(min-width: 1024px)').matches
}
